import PropTypes from 'prop-types'
import React from 'react'
import CopyButton from '../../partials/content/CopyButton'
import UserAvatar from '../UserAvatar/UserAvatar'
import styles from './UserPanelTitle.module.scss'

/**
 * User details panel title: avatar, name with optional badges, and a copyable email.
 */
function UserPanelTitle({
  name = '',
  email = '',
  customerId,
  directoryUserId,
  isSignInBlocked = false,
  children = null,
}) {
  return (
    <div className={styles.title}>
      <UserAvatar customerId={customerId} userId={directoryUserId} name={name} enabled={!!directoryUserId} />

      <div className={styles.text}>
        <div className={styles.nameRow}>
          {isSignInBlocked && (
            <span className="suspended">
              <i className="fa fa-ban" aria-hidden="true" />
            </span>
          )}
          <span className={styles.name}>{name}</span>
          {children && <span className={styles.badges}>{children}</span>}
        </div>

        {email && (
          <div className={styles.emailRow}>
            <span className={`font-color-2 ${styles.email}`}>{email}</span>
            <CopyButton textToCopy={email} className="d-inline-block" />
          </div>
        )}
      </div>
    </div>
  )
}

UserPanelTitle.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  /** Customer whose Microsoft 365 directory holds the user's photo */
  customerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Microsoft 365 object id; without it the avatar shows initials */
  directoryUserId: PropTypes.string,
  /** Shows the blocked sign-in icon before the name */
  isSignInBlocked: PropTypes.bool,
  /** Badges shown beside the name */
  children: PropTypes.node,
}

export default React.memo(UserPanelTitle)
